import { extractDecisioningCreativeComponentNames } from "./extractDecisioningCreativeComponentNames";
import type { DecisioningCreativeComponentName } from "./types";

/**
 * Extracts unique allowed decisioning creative component names from one or more text fields.
 *
 * Email callers should pass `getMessageLiquidTextFields(messageVariation, isTemplate)` so
 * discovery uses the canonical email Liquid text set.
 */
export const extractDecisioningCreativeComponentNamesFromTexts = (
  ...texts: Array<string | null | undefined>
): DecisioningCreativeComponentName[] => {
  const names = texts.flatMap((text) => extractDecisioningCreativeComponentNames(text));
  return [...new Set(names)];
};
